var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "gg-card-title",
                                {
                                  staticClass: "pt-0 pb-0",
                                  attrs: {
                                    subtitle: ""
                                  }
                                },
                                [_vm._v("Choose Application")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("data-view", {
                        attrs: {
                          cols: "4",
                          items: _vm.items
                        },
                        model: {
                          value: _vm.selection,
                          callback: function callback($$v) {
                            _vm.selection = $$v
                          },
                          expression: "selection"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }